import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClientService } from '../../../core/http/api-client.service';
import {
  NotificationTemplatesListResponseDto,
  NotificationTemplateVariablesResponseDto,
  UpsertNotificationTemplateRequest,
} from './notification-templates.models';

@Injectable({
  providedIn: 'root',
})
export class NotificationTemplatesService {
  private readonly apiClient = inject(ApiClientService);

  getList(companyId?: string): Observable<NotificationTemplatesListResponseDto> {
    return this.apiClient.get<NotificationTemplatesListResponseDto>('/notification-templates', {
      companyId,
    });
  }

  getVariableRegistry(
    companyId?: string,
    eventType?: string,
  ): Observable<NotificationTemplateVariablesResponseDto> {
    return this.apiClient.get<NotificationTemplateVariablesResponseDto>(
      '/notification-templates/variables',
      { companyId, eventType },
    );
  }

  create(
    payload: UpsertNotificationTemplateRequest & { eventType: string },
    companyId?: string,
  ): Observable<unknown> {
    return this.apiClient.post('/notification-templates', payload, { companyId });
  }

  update(
    eventType: string,
    payload: UpsertNotificationTemplateRequest,
    companyId?: string,
  ): Observable<unknown> {
    return this.apiClient.patch(
      `/notification-templates/${encodeURIComponent(eventType)}`,
      payload,
      { companyId },
    );
  }

  delete(eventType: string, companyId?: string): Observable<{ deleted: true }> {
    return this.apiClient.delete<{ deleted: true }>(
      `/notification-templates/${encodeURIComponent(eventType)}`,
      { companyId },
    );
  }

  sendTemplateTest(
    eventType: string,
    toEmail: string,
    companyId?: string,
  ): Observable<{ sent: true; source: string }> {
    return this.apiClient.post<{ sent: true; source: string }, { toEmail: string }>(
      `/notification-templates/${encodeURIComponent(eventType)}/test`,
      { toEmail },
      { companyId },
    );
  }
}
